var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-embed',{attrs:{"src":_vm.url,"type":"iframe","aspect":"16by9","allowfullscreen":"","lazy":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }